import { GetterTree } from "vuex";
import { RootGetters } from "./enums";
import RootState from "./rootState";

const getters: GetterTree<RootState, RootState> = {};
getters[RootGetters.GetRequestStatus] = (rootState: RootState): boolean => rootState.requestLoading;
getters[RootGetters.GetRedirect] = (rootState: RootState): string => rootState.redirect;
export default getters;
